module.exports = __webpack_public_path__ + "img/wallet.12723405.png";